module.exports = __webpack_public_path__ + "img/stapel-text-03.11275fbd.svg";